import { IAudioNode, IAudioParam } from '../interfaces';
import { TContext } from '../types';

export const isAudioNode = <T extends TContext>(
    audioNodeOrAudioParam: IAudioNode<T> | IAudioParam
): audioNodeOrAudioParam is IAudioNode<T> => {
    return 'context' in audioNodeOrAudioParam;
};
